export default "https://embed.voomly.com/embed/skin-06.0b9b3ef.png";